import React from 'react';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import Button from 'components/theme/button';

export default function FreatureFormToggle({ feature, onSubmit, onFormClose }) {
  const { key, appId } = feature;

  const onSubmitDelete = () => {
    onSubmit({ key, appId });
  };

  return (
    <>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          This will delete the <b>{key}</b> flag from all environments and the
          feature flag value defined in code will be returned for all your
          users. You should remove all references to this feature flag from your
          application code before deleting it from here.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onFormClose}
          color="secondary"
          name="cancel"
          data-testid="cancel-form"
        >
          Cancel
        </Button>
        <Button
          onClick={onSubmitDelete}
          color="danger"
          variant="contained"
          data-testid="submit-form"
        >
          Delete
        </Button>
      </DialogActions>
    </>
  );
}
